import { Text } from '@mantine/core';

import styles from './gradient-legend.module.css';

interface GradientLegendProps {
  legend: Record<string, string>;
}

export function GradientLegend({ legend }: GradientLegendProps) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          height: '150px',
        }}
      >
        {Object.keys(legend)
          .sort()
          .reverse()
          .filter(
            (_, index, array) =>
              index === 0 ||
              index === Math.floor(array.length / 4) ||
              index === Math.floor(array.length / 2) ||
              index === Math.floor((array.length * 3) / 4) ||
              index === array.length - 1,
          )
          .map((key) => (
            <Text key={key} size="xs" ta="right">
              {key}
            </Text>
          ))}
      </div>
      <div
        style={{
          width: '30px',
          height: '150px',
          background: `linear-gradient(to top, ${Object.entries(legend)
            .sort()
            .map(([key, value]) => value)
            .join(', ')})`,
          borderRadius: '4px',
        }}
      />
    </div>
  );
}

export default GradientLegend;
